import { render, staticRenderFns } from "./applicationSalonApplyDetail.vue?vue&type=template&id=108b1441&scoped=true&"
import script from "./applicationSalonApplyDetail.vue?vue&type=script&lang=js&"
export * from "./applicationSalonApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./applicationSalonApplyDetail.vue?vue&type=style&index=0&id=108b1441&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b1441",
  null
  
)

export default component.exports